import { render, staticRenderFns } from "./selectSectors.vue?vue&type=template&id=52f0b7be&"
import script from "./selectSectors.vue?vue&type=script&lang=js&"
export * from "./selectSectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports